<div appFont
     id="powered-by-container"
     class="powered-by-container"
     [hierarchy]="types.FontHierarchy.Primary"
     [type]="types.FontType.SemiBold">
  <a href="https://krugoapp.com" target="_blank"><ng-content></ng-content></a>
</div>
